import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { config } from './components/pages/config'
import index from './components/pages/Home'
import InstructorIndex from './components/pages/Instructors'
import CoursesIndex from './components/pages/Courses'
import ContactIndex from './components/pages/Contact'
import CourseDetails from './components/pages/Courses/CourseDetails'
import FaqIndex from './components/pages/Faqs'
import InstructorDetails from './components/pages/Instructors/InstructorDetails'
import BookingIndex from './components/pages/Booking'
import AboutTheoryCourse from './components/pages/About Courses/AboutTheoryCourse'
import AboutPracticalCourse from './components/pages/About Courses/AboutPracticalCourse'
import BecomeInstructor from './components/pages/Instructors/BecomeInstructor'
import BlogIndex from './components/pages/Blogs'
import BlogDetails from './components/pages/Blogs/BlogDetails'
import LocationsIndex from './components/pages/Locations'
import TermsConditions from './components/pages/Company Details/TermsConditions'
import PrivacyPolicy from './components/pages/Company Details/PrivacyPolicy'
import RefundDelivery from './components/pages/Company Details/RefundDelivery'
import GetStarted from './components/pages/Get Started'
import RefresherPage from './components/pages/Refresher driver'
import Gallery from './components/pages/Gallery/Gallery'
import NotFound from './components/common/NotFound'
import PaymentSuccess from './components/common/PaymentSuccess'

const AllRoutes = () => {

    const location = useLocation()

    useEffect(() => {
        // move to top when page change
        window.scrollTo({ top: 0, behavior: 'instant' })
    }, [location.pathname])

    return (
        <Routes>
            <Route path="*" Component={NotFound} />
            <Route path={`${config.appUrl}`} Component={index} />
            <Route path={`${config.appUrl}get-started`} Component={GetStarted} />
            <Route path={`${config.appUrl}instructors`} Component={InstructorIndex} />
            <Route path={`${config.appUrl}instructor`} Component={InstructorDetails} />
            <Route path={`${config.appUrl}courses`} Component={CoursesIndex} />
            <Route path={`${config.appUrl}course/:course_slug`} Component={CourseDetails} />
            <Route path={`${config.appUrl}contact-us`} Component={ContactIndex} />
            <Route path={`${config.appUrl}faqs`} Component={FaqIndex} />
            <Route path={`${config.appUrl}refresher-driver-lessons`} Component={RefresherPage} />
            <Route path={`${config.appUrl}blogs`} Component={BlogIndex} />
            <Route path={`${config.appUrl}blog/:post_slug`} Component={BlogDetails} />
            <Route path={`${config.appUrl}gallery`} Component={Gallery}/>

            {/* Booking Process Routes */}
            <Route path={`${config.appUrl}book-a-lesson`} Component={BookingIndex} />
            <Route path={`${config.appUrl}our-locations`} Component={LocationsIndex} />

            <Route path={`${config.appUrl}about-theory-test`} Component={AboutTheoryCourse} />
            <Route path={`${config.appUrl}about-practical-test`} Component={AboutPracticalCourse} />

            <Route path={`${config.appUrl}how-to-become-instructor`} Component={BecomeInstructor} />
            <Route path={`${config.appUrl}terms-and-conditions`} Component={TermsConditions} />
            <Route path={`${config.appUrl}privacy-policy`} Component={PrivacyPolicy} />
            <Route path={`${config.appUrl}refund-and-Delivery`} Component={RefundDelivery} />

            <Route path={`${config.appUrl}payment/:pay_status`} Component={PaymentSuccess} />

        </Routes>
    )
}

export default AllRoutes